import { combineReducers } from 'redux';
import {
    GET_DEVICES_DATA,
    UPDATE_DEVICES_DATA,
    DELETE_DEVICES_DATA,
    GET_DEVICES_PING_STATUS,
    DEVICE_ONBOARDING,
    TOGGLE_DEVICES_MONITORING_STATUS,
    GET_DEVICES_DASHBOARD_DATA
} from './actionTypes';

const deviceInitialState = {
    devices: [],
    loading: false,
    error: null,
    updateSuccess: false,
    updateError: null,
    deleteSuccess: false,
    deleteError: null,
    toggleSuccess: false,
    toggleError: null
};

export const deviceReducer = (state = deviceInitialState, action = { type: '', payload: null }) => {
    switch (action.type) {
        case GET_DEVICES_DATA.INIT:
            return { ...state, loading: true, error: null };
        case GET_DEVICES_DATA.SUCCESS:
            return {
                ...state,
                loading: false,
                devices: action.payload,
                error: null,
                updateSuccess: false, updateError: null,
                deleteSuccess: false, deleteError: null,
                toggleSuccess: false, toggleError: null
            };
        case GET_DEVICES_DATA.ERROR:
            return { ...state, loading: false, error: action.payload };
        case GET_DEVICES_DATA.CLEAR:
            return { ...deviceInitialState };

        case UPDATE_DEVICES_DATA.INIT:
            return { ...state, updateSuccess: false, updateError: null };
        case UPDATE_DEVICES_DATA.SUCCESS:
            return { ...state, updateSuccess: true, updateError: null };
        case UPDATE_DEVICES_DATA.ERROR:
            return { ...state, updateSuccess: false, updateError: action.payload };
        case UPDATE_DEVICES_DATA.CLEAR:
            return { ...state, updateSuccess: false, updateError: null };

        case DELETE_DEVICES_DATA.INIT:
            return { ...state, deleteSuccess: false, deleteError: null };
        case DELETE_DEVICES_DATA.SUCCESS:
            return { ...state, deleteSuccess: true, deleteError: null };
        case DELETE_DEVICES_DATA.ERROR:
            return { ...state, deleteSuccess: false, deleteError: action.payload };
        case DELETE_DEVICES_DATA.CLEAR:
            return { ...state, deleteSuccess: false, deleteError: null };

        case TOGGLE_DEVICES_MONITORING_STATUS.INIT:
            return { ...state, toggleSuccess: false, toggleError: null };
        case TOGGLE_DEVICES_MONITORING_STATUS.SUCCESS:
            return { ...state, toggleSuccess: true, toggleError: null };
        case TOGGLE_DEVICES_MONITORING_STATUS.ERROR:
            return { ...state, toggleSuccess: false, toggleError: action.payload };
        case TOGGLE_DEVICES_MONITORING_STATUS.CLEAR:
            return { ...state, toggleSuccess: false, toggleError: null };

        default:
            return state;
    }
};

const pingStatusInitialState = {
    summary: null,
    devices: [],
    loading: false,
    error: null
};

export const pingStatusReducer = (state = pingStatusInitialState, action = { type: '', payload: null }) => {
    switch (action.type) {
        case GET_DEVICES_PING_STATUS.INIT:
            return { ...state, loading: true, error: null };
        case GET_DEVICES_PING_STATUS.SUCCESS:
            return {
                ...state,
                loading: false,
                summary: action.payload.summary,
                devices: action.payload.devices,
                error: null
            };
        case GET_DEVICES_PING_STATUS.ERROR:
            return { ...state, loading: false, error: action.payload };

        case GET_DEVICES_PING_STATUS.CLEAR:
            return { ...pingStatusInitialState };

        default:
            return state;
    }
};

const onboardingInitialState = {
    loading: false,
    success: false,
    error: null,
    response: null
};

export const deviceOnboardingReducer = (state = onboardingInitialState, action = { type: '', payload: null }) => {
    switch (action.type) {
        case DEVICE_ONBOARDING.INIT:
            return { ...onboardingInitialState, loading: true };
        case DEVICE_ONBOARDING.SUCCESS:
            return { ...state, loading: false, success: true, error: null, response: action.payload };
        case DEVICE_ONBOARDING.ERROR:
            return { ...state, loading: false, success: false, error: action.payload, response: null };
        case DEVICE_ONBOARDING.CLEAR:
            return { ...onboardingInitialState };
        default:
            return state;
    }
};

const dashboardInitialState = {
    dashboardData: null,
    loading: false,
    error: null
};

export const dashboardReducer = (state = dashboardInitialState, action = { type: '', payload: null }) => {
    switch (action.type) {
        case GET_DEVICES_DASHBOARD_DATA.INIT:
            return { ...state, loading: true, error: null, dashboardData: null };
        case GET_DEVICES_DASHBOARD_DATA.SUCCESS:
            return { ...state, loading: false, dashboardData: action.payload, error: null };
        case GET_DEVICES_DASHBOARD_DATA.ERROR:
            return { ...state, loading: false, error: action.payload, dashboardData: null };

        case GET_DEVICES_DASHBOARD_DATA.CLEAR:
            return { ...dashboardInitialState };

        default:
            return state;
    }
};

export default combineReducers({
    device: deviceReducer,
    pingStatus: pingStatusReducer,
    deviceOnboarding: deviceOnboardingReducer,
    dashboard: dashboardReducer
});
